export default {
      id: "ic-plan-etudes-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-etudes-usage",
      toString: function () {
        return this.url;
      }
    }